import React, { useEffect, useState } from "react";
import classes from "./WatchlistModal.module.css";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import {
  openSubWatchList,
  toggleWatchlistModal,
  shutDownWatchlistModal,
} from "../Slices/watchlistModalSlice";
import { useAnimationControls, motion } from "framer-motion";
import BackgroundWatchlist from "./BackgroundWatchlist";
import { InputText } from "primereact/inputtext";
import {
  useAddItemInWatchlistMutation,
  useCreateWatchlistMutation,
  useDeleteWatchlistMutation,
  useEditWatchlistMutation,
  useGetUserWatchlistQuery,
  useRemoveItemFromWatchlistMutation,
} from "../Slices/httpSlice";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import WatchlistSubModal from "./WatchlistSubModal";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../Slices/userSlice";

const WatchlistModal = () => {
  const { watchlistModal } = useAppSelector(
    (state) => state.watchlistModalSlice
  );

  const { user } = useAppSelector((state) => state.userSlice);

  const dispatch = useAppDispatch();

  const [createWatchlistApi, { isLoading: createWatchlistLoading }] =
    useCreateWatchlistMutation();

  const [addItemInWatchlistApi, { isLoading: addItemInWatchlistLoading }] =
    useAddItemInWatchlistMutation();

  const [
    removeItemFromWatchlistApi,
    { isLoading: removeItemFromWatchlistLoading },
  ] = useRemoveItemFromWatchlistMutation();

  const [editWatchlistApi, { isLoading: editWatchlistLoading }] =
    useEditWatchlistMutation();

  const [deleteWatchlistApi, { isLoading: deleteWatchlistLoading }] =
    useDeleteWatchlistMutation();

  const {
    data: watchlists,
    refetch: watchlistsRefetch,
    isFetching: watchlistsLoading,
    isError: watchlistsIsError,
    error: watchlistsError,
  } = useGetUserWatchlistQuery(
    {
      user_id: user?.id,
      token: user?.token,
    },
    {
      skip: !watchlistModal,
    }
  );

  useEffect(() => {
    if (watchlistsIsError && watchlistModal) {
      let error: any = watchlistsError;
      if (error?.status == 403) {
        toast.error("Your Session has been Expired! Login Again");
        dispatch(logoutUser(null));
        closeWatchlistModal();
        navigate("/");

      }
    }
  }, [watchlistsIsError, watchlistModal]);

  const navigate = useNavigate();

  const controls = useAnimationControls();

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  useEffect(() => {
    if (watchlistModal) {
      controls.start("visible");
      watchlistsRefetch();
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [watchlistModal]);

  const closeWatchlistModal = () => {
    controls.start("hidden");
    dispatch(toggleWatchlistModal());
  };

  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (
    event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>,
    data: any
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      console.log(data, "data...");
      //   closeWatchlistModal();

      const filteredData = watchlists?.result?.filter(
        (dataItem: any) => dataItem?.watchlist_id === data?.watchlist_id
      );
      let watchlist_items = filteredData[0]?.watchlist_items;
      dispatch(
        openSubWatchList({
          watchlist_id: data?.watchlist_id,
          watchlist_items: watchlist_items,
        })
      );
    }
  };

  const handleMouseUp2 = async (
    event: React.MouseEvent<HTMLButtonElement>,
    data: any
  ) => {
    event.stopPropagation();

    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      let navigatePath = `${
        data?.media_type === "tv"
          ? `/series/${data?.media_id}/${data?.media_name}`
          : `/movies/${data?.media_id}/${data?.media_name}`
      }`;
      dispatch(shutDownWatchlistModal());
      navigate(navigatePath);
    }
  };

  const handleMouseUp3 = async (
    event: React.MouseEvent<HTMLDivElement>,
    data: any
  ) => {
    event.stopPropagation();
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      //   closeWatchlistModal();

      const response: any = await removeItemFromWatchlistApi({
        body: {
          watchlist_id: data?.watchlist_id,
          media_id: data?.media_id,
          media_type: data?.media_type,
        },
        token: user?.token,
      });

      if (response?.error) {
        if (response?.error?.status === 403) {
          toast.error("Please Login Again, Token Expired!");
        } else {
          toast.error(
            "Something Went Wrong!" ||
              response?.error?.data?.error?.error ||
              response?.error?.data?.error ||
              response?.error?.data?.message ||
              response?.error?.message
          );
        }
      } else {
        watchlistsRefetch();
        toast.success("Item removed from watchlist successfully!");
      }
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  const [open, setOpen] = useState<boolean>(false);

  const [watchlist, setWatchlist] = useState("");

  const handleCreateList = () => {
    setOpen((prevValue) => !prevValue);
  };

  const handleAddList = async () => {
    if (watchlist.trim().length === 0) {
      toast.error("Please enter the name of list!");
      return;
    }
    const response: any = await createWatchlistApi({
      body: {
        user_id: user.id,
        watchlist: watchlist,
        date_time: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      token: user?.token,
    });

    if (response?.error) {
      if (response?.error?.status === 403) {
        toast.error("Your session has expired! Login Again!");
        dispatch(logoutUser(null));
        navigate("/");


      } else if (response.error?.data?.error?.status === 0) {
        toast.error("Watchlist with this name already exists!");
      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      setOpen(false);
      setWatchlist("");
      watchlistsRefetch();
      toast.success("WatchList Created Successfully!");
    }
  };

  console.log(watchlists, "w");

  const [editing, setEditing] = useState<any>({
    state: false,
    data: {},
  });

  const [watchlistEditName, setWatchlistEditName] = useState<string>("");

  useEffect(() => {
    setWatchlistEditName(editing?.data?.watchlist_name);
  }, [editing]);

  console.log(editing, "editing...");

  const editHandler = async () => {
    if (watchlistEditName.trim().length === 0) {
      toast.error("Please enter the name of watchlist!");
      return;
    }
    const response: any = await editWatchlistApi({
      body: {
        watchlist_id: editing?.data?.watchlist_id,
        watchlist_name: watchlistEditName,
      },
      token: user?.token,
    });

    if (response?.error) {
      if (response?.error?.status === 403) {
        toast.error("Your session has expired! Login Again!");
        dispatch(logoutUser(null));

      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      setEditing({ state: false, data: {} });
      watchlistsRefetch();
      toast.success("WatchList Edited Successfully!");
    }
  };

  const [modal, setModal] = useState(false);

  const modalHandler = () => {
    setModal((prevValue) => !prevValue);
  };

  const deleteHandler = async () => {
    const response: any = await deleteWatchlistApi({
      body: {
        watchlist_id: editing?.data?.watchlist_id,
      },
      token: user?.token,
    });

    if (response?.error) {
      if (response?.error?.status === 403) {
        toast.error("Your session has expired! Login Again!");
        dispatch(logoutUser(null));

      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      setEditing({ state: false, data: {} });
      setModal(false);
      watchlistsRefetch();
      toast.success("Full Watchlist Deleted Successfully!");
    }
  };
  return (
    <motion.div
      className={classes.modal}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        type: "spring",
        damping: 10,
        stiffness: 100,
      }}
    >
      <BackgroundWatchlist>
        <div className={classes.navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={closeWatchlistModal}
          >
            <i className={`pi pi-times ${classes.close_icon}`} />
          </button>
        </div>
        <div className={classes.info_container}>
          <p className={classes.info}>Your Watchlist</p>
          <p className={classes.info_brief}>
            Your Watchlist is the place to track the titles you want to watch.
          </p>
          <div className={classes.create_list_btn} onClick={handleCreateList}>
            Create a New List
            <div className={classes.separator}>
              <div className={classes.line}></div>
              {open ? (
                <i className={`pi pi-chevron-up ${classes.chevron}`} />
              ) : (
                <i className={`pi pi-chevron-down ${classes.chevron}`} />
              )}
            </div>
            {open && (
              <div
                className={classes.inputs}
                onClick={(e) => e.stopPropagation()}
              >
                <InputText
                  type="text"
                  className={`p-inputtext-lg ${classes.input}`}
                  placeholder="List Title"
                  autoFocus={true}
                  value={watchlist}
                  onChange={(e) => setWatchlist(e.target.value)}
                />
                <button
                  type="button"
                  className={classes.add_btn}
                  onClick={handleAddList}
                  disabled={createWatchlistLoading}
                >
                  {createWatchlistLoading ? (
                    <div className={classes.spinner}></div>
                  ) : (
                    "Add"
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </BackgroundWatchlist>

      <div className={classes.watchlist_content}>
        {watchlists?.result.length === 0 ? (
          <p className={classes.message}>Your watchlist is empty!</p>
        ) : (
          <React.Fragment>
            {watchlists?.result.map((data: any, idx: number) => {
              return (
                <div key={idx} className={classes.watchlist}>
                  <div className={classes.watchlist_header}>
                    {editing?.state === true &&
                    editing.data?.watchlist_id === data?.watchlist_id ? (
                      <div className={classes.watchlist_edit_container}>
                        <InputText
                          type="text"
                          className={`p-inputtext-lg ${classes.edit_input}`}
                          placeholder="Watchlist Name"
                          autoFocus={true}
                          value={watchlistEditName}
                          onChange={(e) => setWatchlistEditName(e.target.value)}
                        />
                        <div className={classes.edit_btns}>
                          <button
                            className={classes.edit_done_btn}
                            onClick={() => editHandler()}
                          >
                            <i
                              className={`pi pi-check ${classes.edit_done_icon}`}
                            />
                          </button>
                          <button
                            className={classes.edit_close_btn}
                            onClick={() =>
                              setEditing({ state: false, data: {} })
                            }
                          >
                            <i
                              className={`pi pi-times ${classes.edit_close_icon}`}
                            />
                          </button>
                          <button
                            className={classes.edit_trash_btn}
                            // onClick={() => deleteHandler()}
                            onClick={() => modalHandler()}
                          >
                            <i
                              className={`pi pi-trash ${classes.edit_trash_icon}`}
                            />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <p className={classes.watchlist_name}>
                        {data?.watchlist_name}
                        <i
                          className={`pi pi-pencil ${classes.edit_icon}`}
                          onClick={() =>
                            setEditing({ state: true, data: data })
                          }
                        />
                      </p>
                    )}
                  </div>

                  <motion.div
                    className={classes.watchlist_items}
                    style={{
                      gridTemplateColumns: `repeat(${data?.watchlist_items?.length + 1}, 150px)`,
                    }}
                    drag="x"
                    dragConstraints={{
                      top: 0,
                      left:-(window.innerWidth <= 800
                        ? 10 +
                        (data?.watchlist_items?.length + 1) * 150 +
                          (data?.watchlist_items?.length + 1) * 20 +
                          (data?.watchlist_items?.length + 1) * 1 + 20 -
                          window.innerWidth
                        : window.innerWidth * 0.05 +
                          (data?.watchlist_items?.length + 1) * 150 +
                          (data?.watchlist_items?.length + 1) * 20 +
                          (data?.watchlist_items?.length + 1) * 1 + 20 -
                          window.innerWidth),
                      right: 0,
                      bottom: 0,
                    }}
                    transition={{
                      type: "spring",
                      damping: 100,
                      stiffness: 100,
                    }}
                  >
                    <button
                      key={idx}
                      //   className={classes.add_item_skeleton}
                      className={classes.main_card}
                      onMouseDown={(event) => handleMouseDown(event)}
                      onMouseUp={(event) => handleMouseUp(event, data)}
                      onMouseMove={handleMouseMove}
                    >
                      <div className={classes.add_item_content}>
                        <i className={`pi pi-plus ${classes.plus_icon}`} />
                        <p className={classes.add_item_txt}>
                          Add Items in this watchlist
                        </p>
                      </div>
                    </button>
                    {data?.watchlist_items?.map(
                      (dataItem: any, idx2: number) => {
                        return (
                          <button
                            className={classes.main_card}
                            onMouseDown={(event) => handleMouseDown(event)}
                            onMouseUp={(event) =>
                              handleMouseUp2(event, dataItem)
                            }
                            onMouseMove={handleMouseMove}
                            key={idx2}
                          >
                            <div className={classes.main_card_image}>
                              <img
                                src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                                  "<replace_media_id>",
                                  dataItem?.media_poster
                                )}`}
                                alt="movie"
                                className={classes.main_card_img}
                              />
                            </div>
                            <div className={classes.main_card_content}>
                              <p className={classes.main_card_title}>
                                {dataItem?.media_name}
                              </p>
                            </div>
                            <div
                              className={classes.remove_icon}
                              onMouseDown={(event) => handleMouseDown(event)}
                              onMouseUp={(event) =>
                                handleMouseUp3(event, dataItem)
                              }
                              onMouseMove={handleMouseMove}
                            >
                              <i className={`pi pi-times ${classes.remove}`} />
                            </div>
                          </button>
                        );
                      }
                    )}
                  </motion.div>
                </div>
              );
            })}
          </React.Fragment>
        )}
      </div>
      <WatchlistSubModal />
      {modal && (
        <>
          <div className={classes.alert_modal}>
            <div className={classes.alert}>
              <i
                className={`pi pi-exclamation-triangle ${classes.alert_icon}`}
              />

              <p className={classes.alert_txt}>
                This action will delete '{editing?.data?.watchlist_name}'
                Watchlist and the items that it contains.
              </p>

              <div className={classes.alert_btns}>
                <button
                  type="button"
                  className={classes.cancel_btn}
                  onClick={() => setModal((prevValue) => !prevValue)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={classes.delete_btn}
                  onClick={() => deleteHandler()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </motion.div>
  );
};

export default WatchlistModal;
